import { createTheme } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';

export const createCustomTheme = (mode: 'light' | 'dark') =>
  createTheme(
    {
      palette: {
        mode,
        ...(mode === 'light'
          ? {
              primary: { main: '#16A34A', light: '#22C55E', dark: '#15803D' },
              secondary: { main: '#D97706', light: '#F59E0B', dark: '#B45309' },
              background: { default: '#F9FAF5', paper: '#FFFFFF' },
              text: { primary: '#1C1917', secondary: '#57534E' },
              divider: '#E7E5E4',
              success: { main: '#059669' },
              error: { main: '#DC2626' },
              warning: { main: '#D97706' },
              info: { main: '#0EA5E9' },
            }
          : {
              primary: { main: '#4ADE80', light: '#86EFAC', dark: '#22C55E' },
              secondary: { main: '#FCD34D', light: '#FDE68A', dark: '#F59E0B' },
              background: { default: '#0D1B0D', paper: '#152015' },
              text: { primary: '#F0FDF4', secondary: '#A3A8A3' },
              divider: '#1E3A1E',
              success: { main: '#22C55E' },
              error: { main: '#F87171' },
              warning: { main: '#FCD34D' },
              info: { main: '#38BDF8' },
            }),
      },
      typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h6: { fontWeight: 700 },
      },
      shape: { borderRadius: 10 },
      components: {
        MuiButton: {
          styleOverrides: {
            root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
          },
        },
        MuiPaper: {
          styleOverrides: { root: { backgroundImage: 'none' } },
        },
        MuiChip: {
          styleOverrides: { root: { fontWeight: 600 } },
        },
      },
    },
    frFR
  );
